import { Box, Dialog } from '@mui/material';
import React from 'react';
import { useShallow } from 'zustand/react/shallow';
import useOrderBookStore from '../../stores/OrderBook/orderBook.store';
import OrderActiveMenuContent from './components/OrderActiveMenuContent/OrderActiveMenuContent';
import { useOrderBookStyles } from './styles/OrderBookStyles';

const OrderBookModal: React.FC = () => {
  const orderBookModalState = useOrderBookStore(useShallow((state) => state.orderBookModalState));
  const { classes } = useOrderBookStyles();

  return (
    <Dialog open={orderBookModalState} fullWidth fullScreen maxWidth="xl">
      <Box className={classes.modalContainer}>
        <OrderActiveMenuContent />
      </Box>
    </Dialog>
  );
};

export default OrderBookModal;
